module.exports = __webpack_public_path__ + "static/media/evernote.cf8249a2.svg";